import { render, staticRenderFns } from "./ManagementFeeSubtract.vue?vue&type=template&id=54ee5cc4&scoped=true"
import script from "./ManagementFeeSubtract.vue?vue&type=script&lang=js"
export * from "./ManagementFeeSubtract.vue?vue&type=script&lang=js"
import style0 from "./ManagementFeeSubtract.vue?vue&type=style&index=0&id=54ee5cc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee5cc4",
  null
  
)

export default component.exports